import script from "./cart-component-mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./cart-component-mobile.vue?vue&type=script&setup=true&lang=js"

import "./cart-component-mobile.vue?vue&type=style&index=0&id=53b8960e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b8960e"]])

export default __exports__